<template>
  <v-container fluid class="d-sm-none">
    <v-row>
      <v-col>
        <search-bar />
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="sass">
@use "~/assets/css/vuetify/settings" as *

@media #{map-get($display-breakpoints, 'sm-and-down')}
  .d-sm-none
    display: none

</style>
